import { takeEvery, call, put, all } from "redux-saga/effects";
import { actionTypes, actions } from "./actions";
import { actions as commonActions } from "../../../store/actions";
import { getAccountBalanceList, getAccountBalanceDetails } from "./endpoints";

function* getAccountBalanceListSaga(action) {
  try {
    yield put(commonActions.setLoading(true));
    const _api = yield call(getAccountBalanceList, action.payload);
    yield put(actions.setAccountBalanceList(_api.data.results));
    yield put(commonActions.setLoading(false));
  } catch (error) {
    yield put(commonActions.setLoading(false));
    console.log(error);
  }
}

function* getAccountBalanceDetailsSaga(action) {
  try {
    yield put(commonActions.setLoading(true));
    const _api = yield call(getAccountBalanceDetails, action.payload);
    yield put(actions.setAccountBalanceDetails(_api.data.results));
    yield put(commonActions.setLoading(false));
  } catch (error) {
    yield put(commonActions.setLoading(false));
    console.log(error);
  }
}


export function* withAccountBalanceSaga() {
  yield all([
    takeEvery(actionTypes.GET_ACCOUNT_BALANCE_LIST, getAccountBalanceListSaga),
    takeEvery(actionTypes.GET_ACCOUNT_BALANCE_DETAILS, getAccountBalanceDetailsSaga),
  ]);
}
